import { CheckoutColorVariantEnum } from 'obt-common';
import { Typography } from '@spotnana/blocks/src/Typography';
import { Row, SubTextContainer, TooltipTextContainer } from './styles';
import TooltipInfo from './TooltipInfo';

interface IProps {
  label: string;
  value: string;
  subTextLeft?: string;
  subTextRight?: string;
  colorVariant?: CheckoutColorVariantEnum;
  toolTipText?: string;
}

const Normal = ({ label, value, subTextLeft, subTextRight, colorVariant, toolTipText }: IProps) => {
  return (
    <>
      <Row data-testid="fare-breakup-row">
        {toolTipText ? (
          <TooltipTextContainer>
            <Typography variant="body1" color={getColorFromVariant(colorVariant)} as="dt">
              {label}
            </Typography>
            <TooltipInfo toolTipText={toolTipText} />
          </TooltipTextContainer>
        ) : (
          <Typography variant="body1" color={getColorFromVariant(colorVariant)} as="dt">
            {label}
          </Typography>
        )}
        <Typography variant="body1" color={getColorFromVariant(colorVariant)} as="dd">
          {value}
        </Typography>
      </Row>
      {!!(subTextLeft || subTextRight) && (
        <SubTextContainer subTextLeft={subTextLeft} subTextRight={subTextRight}>
          <>
            {subTextLeft && (
              <Typography variant="body2" color="secondary" as="span">
                {subTextLeft}
              </Typography>
            )}
            {subTextRight && (
              <Typography variant="body2" color="secondary" as="span">
                {subTextRight}
              </Typography>
            )}
          </>
        </SubTextContainer>
      )}
    </>
  );
};

export default Normal;

function getColorFromVariant(colorVariant: CheckoutColorVariantEnum | undefined) {
  if (colorVariant === CheckoutColorVariantEnum.SUCCESS) {
    return 'success' as const;
  }

  if (colorVariant === CheckoutColorVariantEnum.DANGER) {
    return 'error' as const;
  }
  return 'primary' as const;
}
